export default "__VITE_ASSET__DNCW2VJV__"